import type { ToolFactory } from './types';
import type { ITool } from './types';
import type { IServiceManager } from '../core/types';

/**
 * Static global registry of tool factories.
 *
 * Tools register their factory functions here during app initialization.
 * ToolGroups use this registry to instantiate tool instances.
 */
export class ToolRegistry {
    private static factories = new Map<string, ToolFactory>();

    static register(toolId: string, factory: ToolFactory): void {
        if (this.factories.has(toolId)) {
            console.warn(`[ToolRegistry] Tool '${toolId}' already registered, overwriting`);
        }
        this.factories.set(toolId, factory);
    }

    static create(toolId: string, services: IServiceManager): ITool | null {
        const factory = this.factories.get(toolId);
        if (!factory) {
            console.error(`[ToolRegistry] Unknown tool: '${toolId}'`);
            return null;
        }
        return factory(services);
    }

    static has(toolId: string): boolean {
        return this.factories.has(toolId);
    }

    static getRegisteredIds(): string[] {
        return Array.from(this.factories.keys());
    }

    static clear(): void {
        this.factories.clear();
    }
}
